module.exports = __webpack_public_path__ + "media/images/frontend/en-d43908f5d149471b69bd2664a09b7756.png";